<template>
    <label
        :for="id"
        :class="labelClass"
        class="d-flex font--16 lh--20 mb-0 position-relative"
        @click.prevent="input"
    >
        <input
            :id="id"
            :checked="value"
            :disabled="disabled"
            type="radio"
            class="p-0 opacity--0 position-absolute"
            @change="input"
        />

        <v-icon
            :name="value ? 'radiobutton-check' : 'radiobutton-empty'"
            :w="22"
            :class="iconColorClass"
            class="mr-8"
        />

        <slot />
    </label>
</template>

<script>
import uniqueId from "lodash/uniqueId"

export default {
    props: {
        value: Boolean,
        disabled: Boolean,
    },

    emits: ["update:value"],

    data() {
        return {
            id: uniqueId(),
        }
    },

    computed: {
        labelClass() {
            return {
                "cursor--pointer text-dark": !this.disabled,
                "cursor--not-allowed text-gray-medium": this.disabled,
            }
        },

        iconColorClass() {
            const textPrimary = this.$css(this.$theme.textPrimary)
            const textPrimaryLight = this.$css(this.$theme.textPrimaryLight)

            return {
                [textPrimary]: !this.disabled && this.value,
                [textPrimaryLight]: this.disabled && this.value,

                "cursor--not-allowed": this.disabled,
                "cursor--pointer": !this.disabled,
                "text-dark": !this.value,
                "hover:text-gray-dark": !this.value && !this.disabled,
            }
        },
    },

    methods: {
        input(event) {
            this.$emit("update:value", !!event.target.checked)
        },
    },
}
</script>
